export enum DrillType {
  Dry = 'Dry',
  Live = 'Live'
}
